module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag40_1899AT.8592ffa0.jpg";